var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStockMarket = function SvgStockMarket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "stock-market_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#stock-market_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.442 7.484a1.183 1.183 0 0 0-.999 1.817l-2.676 2.879a1.178 1.178 0 0 0-1.368.178l-2.358-1.515a1.183 1.183 0 1 0-2.13.287l-2.826 3.143a1.183 1.183 0 1 0 .452.394l2.812-3.128a1.18 1.18 0 0 0 1.375-.186l2.354 1.511a1.183 1.183 0 1 0 2.126-.275L17.88 9.71a1.183 1.183 0 1 0 .56-2.226h.002Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "stock-market_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgStockMarket as ReactComponent };